import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NotificationsPageComponent } from './components';
import { HubNotificationsWithoutRoutingModule } from './hub-notifications-without-routing.module';

@NgModule({
    imports: [
        HubNotificationsWithoutRoutingModule,
        RouterModule.forChild([
            {
                path: '',
                pathMatch: 'full',
                component: NotificationsPageComponent,
            },
        ]),
    ],
})
export class HubNotificationsModule {}
